// extracted by mini-css-extract-plugin
export default {"container":"JD-z","dimension":"KD-z","dimensionLabels":"LD-z"};